import React from 'react';
import { Form } from 'antd';
import { useFilterInitialization } from '../../model/useFilterInitialization';
import FilterFooter from '../FilterFooter';
import {
  AdditionalInfoFilterSection,
  AddressFilterSection,
  DateFilterSection,
  FilterSettingsSection,
  LifecycleFilterSection,
  PaidOrdersFilterSection,
  PeopleFilterSection,
  SavedFiltersSection,
  ServiceFilterSection,
  WarrantyFilterSection,
} from '../sections';
import styles from './FilterContainer.module.scss';

const FilterContainer = () => {
  useFilterInitialization();

  return (
    <div className={styles.root}>
      <div className={styles.scrollArea}>
        <Form className={styles.content}>
          <FilterSettingsSection />
          <SavedFiltersSection />
          <DateFilterSection />
          <PeopleFilterSection />
          <ServiceFilterSection />
          <AddressFilterSection />
          <WarrantyFilterSection />
          <LifecycleFilterSection />
          <PaidOrdersFilterSection />
          <AdditionalInfoFilterSection />
        </Form>
      </div>
      <FilterFooter />
    </div>
  );
};

export default FilterContainer;
